import React, { useState, useContext, useEffect, useRef } from 'react'
import './styles.scss'

import AUTH_ACTIONS from '../../../../../store/actions/authAction'

import GeneralInput from '../../../../../components/GeneralInput'
import Button from '../../../../../components/Button'
import contractContext from '../../../../../store/contexts/contractContext'

import AutoComplete from 'react-autocomplete'
import get from 'lodash/get'

import COLORS from '../../../../../styles/colors'

import bankData from '../../../../../constants/brazilian-banks-list'
import { useCommonStyles } from 'styles/globalStyles'
import ErrorComponent from 'components/ErrorComponent'

interface IPropType {
  accountType: string
}

export default function BankData() {
  const containerRef = useRef(null)
  const [accountInputWidth, setAccountInputWidth] = useState(0)
  const commonClasses = useCommonStyles()
  const [errors, setErrors] = useState<string[]>([])

  useEffect(() => {
    getInputWidth()
    // eslint-disable-next-line
  }, [containerRef])
  const {
    auth: {
      userData: { id, accessToken },
      userBankAccount,
      authDispatch,
    },
    services: { getUserBankAccount, createUserBankData },
    handleStepChange,
    setIsLoading,
  } = useContext(contractContext)

  const [bank, setBank] = useState('')
  const [agency, setAgency] = useState('')
  const [account, setAccount] = useState('')
  const [accountType, setAccountType] = useState('')

  const [bankNumber, setBankNumber] = useState('')

  useEffect(() => {
    getBankAccount()
    // eslint-disable-next-line
  }, [])

  const getBankAccount = async () => {
    if (Boolean(userBankAccount.account)) {
      const bank = bankData.find((bank) => bank.id === userBankAccount.bank)

      setBank(get(bank, 'label') || '')
      setBankNumber(userBankAccount.bank)
      setAgency(userBankAccount.agency)
      setAccount(userBankAccount.account)
      setAccountType(userBankAccount.account_type)

      return
    }

    await fetchBankAccountData()
  }

  const fetchBankAccountData = async () => {
    if (Boolean(id) && Boolean(accessToken)) {
      try {
        setIsLoading(true)
        const { data } = await getUserBankAccount(id, accessToken)

        authDispatch({
          type: AUTH_ACTIONS.RECEIVE_USER_BANK_ACCOUNT,
          value: data,
        })

        if (Boolean(data.account)) {
          const bank = bankData.find((bank) => bank.id === data.bank)

          setBank(get(bank, 'label') || '')
          setBankNumber(data.bank)
          setAgency(data.agency)
          setAccount(data.account)
          setAccountType(data.account_type)
        }
      } catch (err) {
        console.log({ err })
      }
      setIsLoading(false)
    }
  }

  const getButtonClassName = (type) => {
    let className = 'button-styling form-fields-size'
    if (type === accountType) className += ' active'

    return className
  }

  const getInputWidth = () => {
    const width = get(containerRef, 'current.clientWidth')

    setAccountInputWidth(Math.round(width * 0.95))
  }

  const accountsInputStyles = {
    width: accountInputWidth,
    ...inputStyles,
  }

  const handleBankSelect = (value, { id }) => {
    setBank(value)
    setBankNumber(id)
  }

  const handleCreateBank = async () => {
    const bankData = {
      bank: bankNumber,
      agency,
      account_type: accountType,
      account,
    }

    try {
      const { data } = await createUserBankData(bankData, id, accessToken)
      authDispatch({
        type: AUTH_ACTIONS.RECEIVE_USER_BANK_ACCOUNT,
        value: data,
      })

      handleStepChange('ImmobileData')
    } catch (e) {
      setErrors(['Não foi possível registrar dados bancários. Por favor verifique o seus dados e tente novamente.'])
    }
  }

  return (
    <div ref={containerRef} className='bank-data-container'>
      <p className={commonClasses.contractSubtitle}>
        Cadastre os dados bancários em que deve ser depositado o aluguel e que serão incorporados ao contrato
        de aluguel.
      </p>
      <AutoComplete
        menuStyle={autocompleteStyles}
        inputProps={{ style: accountsInputStyles }}
        items={bankData}
        shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
        getItemValue={(item) => item.label}
        value={bank}
        onChange={(e) => setBank(e.target.value)}
        onSelect={handleBankSelect}
        renderItem={(item, highlighted) => (
          <div key={item.id} style={{ backgroundColor: highlighted ? '#eee' : 'transparent' }}>
            {item.label}
          </div>
        )}
      />
      <div className='button-row account-type'>
        <Button
          className={getButtonClassName('checking')}
          onClick={() => setAccountType('checking')}
          title='Conta corrente'
        />
        <Button
          className={getButtonClassName('savings')}
          onClick={() => setAccountType('savings')}
          title='Poupança'
        />
      </div>
      <div className='button-row account-type'>
        <GeneralInput
          handleChange={(e) => setAgency(e.target.value)}
          value={agency}
          className='form-fields-size'
          label='Agência'
        />
        <GeneralInput
          handleChange={(e) => setAccount(e.target.value)}
          value={account}
          className='form-fields-size'
          label='Nº da conta'
        />
      </div>

      <ErrorComponent errors={errors} />

      <div className='button-footer'>
        <Button title='Voltar' onClick={() => handleStepChange('TenantRegister')} />
        <Button title='CONTINUAR' onClick={handleCreateBank} />
      </div>
    </div>
  )
}

const autocompleteStyles = {
  borderRadius: '3px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
  background: 'rgba(255, 255, 255, 0.9)',
  padding: '2px 0',
  fontSize: '90%',
  position: 'fixed',
  overflow: 'auto',
  maxHeight: '50%',
  zIndex: 2,
}

const inputStyles = {
  height: 60,
  border: `solid 2px ${COLORS.lightGray}`,
  borderRadius: 5,
  padding: 20,
  boxSizing: 'border-box',
  fontSize: 16,
  color: 'rgba(0,0,0,.6)',
}
